import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ServerService } from '../core/service/server.service';
import { View } from '../core/view/view';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  
  constructor(private http: HttpClient, private server:ServerService, private view:View) { 
    this.inicializar();
  }

  inicializar(){
  }

  getImagemUrl(imagem:string){
    if(!imagem){
      return this.server.getURL()+"/images/sem_imagem.jpeg";
    }
    
    return this.server.getURL()+"/images/"+imagem;
  }


  upload(formData):Observable<any>{

    return Observable.create(
      (obs) => {
        this.server.isLoading.next(true);
        this.http.post<any>(this.server.getURL()+"/upload", formData, { headers:this.server.createExtraRequestHeaders()})
        .subscribe(
          (dados) => {
            this.server.isLoading.next(false);
            obs.next(dados);
          },
          (err) => {
            this.server.isLoading.next(false);
            console.error(err);

            this.view.showMessage("Não foi possível fazer o upload da imagem.", "danger");
            obs.error(err);
          },
          () => {
            obs.complete();
          }
        )

      }
    );
    return this.http.post<any>(this.server.getURL()+"/upload", formData, { headers:this.server.createExtraRequestHeaders()});
  }

}
